import {styled} from '@mui/material/styles'
import {DialogTitle} from '@mui/material'

export const StyledDiv = styled('div', {shouldForwardProp: (prop) => prop !== 'bold'})(({theme, bold}) => ({
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  fontWeight: bold ? theme.typography.heading.fontWeight.bold : '',
  color: theme.palette.common.black,
  fontSize: theme.typography.heading.fontSize.xs
}))

export const StyledDialogTitle = styled(DialogTitle)(({theme}) => ({
  color: theme.palette.common.black,
  fontSize: theme.typography.heading.fontSize.s,
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: theme.typography.heading.fontWeight.bold,
  display: 'flex'
}))
